import { Circle, Close, Triangle } from '@linktivity/link-icons';
import { ALLOTMENT_STATUS } from '@link/share/constants';
import type { StockIconProps } from './StockIcon.types';

const GLYPHS = {
  [ALLOTMENT_STATUS.ALLOCABLE]: Circle,
  [ALLOTMENT_STATUS.LIMITED]: Triangle,
  [ALLOTMENT_STATUS.SOLD_OUT]: Close
};

/**
 * ○ / △ / × for a stock status. Glyph only: each place that shows one colours
 * it for its own background.
 */
const StockIcon = ({ status, className }: StockIconProps) => {
  const Glyph = GLYPHS[status];
  return <Glyph className={className} aria-hidden />;
};

export default StockIcon;
